import { format, isValid } from 'date-fns';

import { Timescale, XRefDate } from 'src/types/models';

const formatPatternByTimescale: Record<Timescale, string> = {
  [Timescale.Yearly]: 'yyyy',
  [Timescale.Quarterly]: "yyyy-'Q'Q",
  [Timescale.Monthly]: 'yyyy-MM',
  [Timescale.Weekly]: 'yyyy-MM-dd',
};

export const buildPeriodLabeler = (dates: XRefDate[], timescale: Timescale) => {
  // Format every known date once; each label call is then a map lookup.
  const pattern = formatPatternByTimescale[timescale];
  const dateMap = new Map<number, string>();
  for (const date of dates) {
    // XREF_Date carries every timescale, and only Monthly/Weekly rows are
    // M/D/YYYY dates (Quarterly is '1900 Q1', Yearly '1900', Launch '1'), so
    // only this timescale's rows are formatted; the rest pass through unchanged.
    if (date.Timescale !== timescale || dateMap.has(date.DateID)) {
      continue;
    }
    const parsed = new Date(date.Date);
    // A date string that does not parse keeps its own text rather than
    // throwing and taking the whole screen down.
    dateMap.set(
      date.DateID,
      isValid(parsed) ? format(parsed, pattern) : date.Date
    );
  }

  return (dateId: string | null): string => {
    if (dateId === null) {
      return 'Value';
    }

    if (/^\d+$/.test(dateId)) {
      const label = dateMap.get(Number(dateId));
      if (label !== undefined) {
        return label;
      }
    }

    // Unknown numeric ids and non-numeric keys (Uptake/Event
    // Curve_Sub_TypeID) pass through unchanged.
    return dateId;
  };
};
